module.exports = __webpack_public_path__ + "static/media/4-deg.2e3990f4.mp3";